import { Component, OnInit } from '@angular/core';
import { Router, RouterEvent } from '@angular/router';
import { UserService } from '../services/user.service';
@Component({
  selector: 'smr-settings',
  templateUrl: './settings.page.html',
  styleUrls: ['./settings.page.scss'],
})
export class SettingsPage implements OnInit {

  pages = [
    {
      title: 'Salon Profile',
      info: 'Your salon details',
      url: '/settings/salon-profile',
      icon: 'location-sharp'
    },
    {
      title: 'Staff',
      info: 'Add/edit/manage staff',
      url: '/settings/stylist-manager',
      icon: 'people'
    },

    {
      title: 'Site Settings',
      info: 'Your booking site settings',
      url: '/settings/site-settings',
      icon: 'earth'
    },
    {
      title: 'Booking Settings',
      info: 'How and when clients can book',
      url: '/settings/booking-settings',
      icon: 'calendar'
    },
    {
      title: 'Services',
      info: 'Your services',
      url: '/settings/services/manager',
      icon: 'cut'
    },
    {
      title: 'Payment Processing',
      info: 'Payment processing settings',
      url: '/settings/payment-processing-settings',
      icon: 'logo-usd'
    },
    {
      title: 'Point of Sale',
      info: 'Sales tracking, taxes & discounts',
      url: '/settings/pos-settings',
      icon: 'card'
    },
    {
      title: 'Hours/Vacations',
      info: 'Set when clients can book',
      url: '/settings/work-day-settings/work-day-list',
      icon: 'time'
    },
    {
      title: 'Social Media Links',
      info: 'Link your social media accounts',
      url: '/settings/social-media-settings',
      icon: 'logo-facebook'
    },
    {
      title: 'Notifications',
      info: 'Manage push notifications',
      url: '/settings/notification-settings',
      icon: 'notifications'
    },
    {
      title: 'Commissions',
      info: 'Commission tracking settings',
      url: '/settings/commission-settings',
      icon: 'calculator'
    },
    {
      title: 'Custom emails',
      info: 'Customize your email text',
      url: '/settings/custom-email-settings',
      icon: 'mail'
    },

    {
      title: 'About',
      info: 'Legal & Privacy',
      url: '/settings/about',
      icon: 'help'
    },
    
    
];

selectedPath = ''; 
user;

constructor(private router: Router, private userService: UserService) { 
  this.router.events.subscribe((event: RouterEvent) => {
    if (event && event.url){
      this.selectedPath = event.url
    }
  })
}

  ngOnInit() {
    if(this.userService.getUser())
      this.user = this.userService.getUser();
  }



}
